var map = {
	"./64_hat.mp3": "9d26",
	"./65_T-shirt.mp3": "42ef",
	"./66_dress.mp3": "ccbe",
	"./67_jumper.mp3": "e25f",
	"./68_jacket.mp3": "336d",
	"./69_shoes.mp3": "a78a",
	"./70_jeans.mp3": "16e1",
	"./M_Brilliant.mp3": "bfb4",
	"./M_Excellent.mp3": "0fd0",
	"./M_Fantastic.mp3": "7a53",
	"./M_Great.mp3": "108b",
	"./M_Perfect.mp3": "2be4",
	"./M_Think again.mp3": "e8c0",
	"./M_Try again.mp3": "c675",
	"./M_Very good.mp3": "3d5f",
	"./M_Well done.mp3": "729a2",
	"./M_Work harder.mp3": "bae7",
	"./click.mp3": "e0cf",
	"./false.mp3": "1b920",
	"./true.mp3": "3b11"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "894b";